import { render } from "./EnrolleeClaimComponent.vue?vue&type=template&id=455b4853&scoped=true"
import script from "./EnrolleeClaimComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeClaimComponent.vue?vue&type=script&lang=js"

import "./EnrolleeClaimComponent.vue?vue&type=style&index=0&id=455b4853&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455b4853"]])

export default __exports__